import { X } from "lucide-react";
import React from "react";
import { Group, Text, ActionIcon, Loader } from "@mantine/core";

interface TagFilterIndicatorProps {
  tagName?: string;
  loading?: boolean;
  onClear: () => void;
}

const TagFilterIndicator: React.FC<TagFilterIndicatorProps> = ({
  tagName,
  loading,
  onClear,
}) => {
  if (loading) {
    return (
      <Group spacing="xs" style={{ marginBottom: 12 }}>
        <Text size="sm">Active tag:</Text>
        <Loader size="xs" />
      </Group>
    );
  }

  if (!tagName) return null;

  return (
    <Group spacing="xs" style={{ marginBottom: 12 }}>
      <Text size="sm">Active tag:</Text>
      <Text size="sm" weight={500} color="blue">
        {tagName}
      </Text>
      <ActionIcon
        size="sm"
        color="red"
        variant="light"
        onClick={onClear}
        aria-label="Clear tag filter"
      >
        <X size={16} />
      </ActionIcon>
    </Group>
  );
};

export default TagFilterIndicator;
